import { useState } from 'react';

export const useModal = (initialMode = false) => {
    const [isOpened, setIsOpened] = useState(initialMode);
    const toogle = () => setIsOpened(!isOpened);
    return [isOpened, setIsOpened, toogle];
}